import type { AxiosPromise } from 'axios';
import BaseClient from './BaseClient';
import type { CursorPaginationResponse } from './api';
import type { CursorPaginationParams } from './BaseClient.types';
import type { PendingAcceptanceGroup, Term, TermAcceptance, TermFormData } from './adminTermsClient.types';

class AdminTermsClient extends BaseClient {
    getTerms(teamId: number, params?: CursorPaginationParams): AxiosPromise<CursorPaginationResponse<Term>> {
        const url = `/api/admin/teams/${teamId}/terms`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getTerm(teamId: number, termId: number): AxiosPromise<Term> {
        const url = `/api/admin/teams/${teamId}/terms/${termId}`;
        return this.makeCoreApiRequest(url);
    }

    createTerm(teamId: number, data: TermFormData): AxiosPromise<Term> {
        const url = `/api/admin/teams/${teamId}/terms`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateTerm(teamId: number, termId: number, data: TermFormData): AxiosPromise<Term> {
        const url = `/api/admin/teams/${teamId}/terms/${termId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    publishTerm(teamId: number, termId: number): AxiosPromise<Term> {
        const url = `/api/admin/teams/${teamId}/terms/${termId}/status`;
        return this.makeCoreApiRequest(url, 'patch', { status: 'published' });
    }

    deleteTerm(teamId: number, termId: number): AxiosPromise<void> {
        const url = `/api/admin/teams/${teamId}/terms/${termId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getTermAcceptances(
        teamId: number,
        termId: number,
        params?: CursorPaginationParams
    ): AxiosPromise<CursorPaginationResponse<TermAcceptance>> {
        const url = `/api/admin/teams/${teamId}/terms/${termId}/acceptances`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getPendingAcceptanceGroups(
        teamId: number,
        termId: number,
        params?: CursorPaginationParams
    ): AxiosPromise<CursorPaginationResponse<PendingAcceptanceGroup>> {
        const url = `/api/admin/teams/${teamId}/terms/${termId}/acceptances/pending`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }
}

export default new AdminTermsClient();
